// TODO: PERFORMANCE - Function uses indexOf instead of includes for string matching. indexOf returns -1 for not found, so the logic checks !== -1. Using includes() would be more readable and modern. Also, the chained ternary operator makes this hard to read - consider using if/else statements or a lookup map.
export const getEnvironment = () => {
    return window.location.host.indexOf('localhost') !== -1
        ? 'localhost'
        : window.location.host.indexOf('orcawebdev') !== -1 || window.location.host.indexOf('dev.orcaweb') !== -1
        ? 'dev'
        : window.location.host.indexOf('orcawebqa') !== -1 || window.location.host.indexOf('qa.orcaweb') !== -1
        ? 'qa'
        : 'prod';
};
